import { render, staticRenderFns } from "./addBuildingView.vue?vue&type=template&id=68c5b179&scoped=true"
import script from "./addBuildingView.vue?vue&type=script&lang=js"
export * from "./addBuildingView.vue?vue&type=script&lang=js"
import style0 from "./addBuildingView.vue?vue&type=style&index=0&id=68c5b179&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c5b179",
  null
  
)

export default component.exports